<template>
  <el-dialog
    top="15vh"
    :visible.sync="showModal"
    :before-close="handleClose"
    :append-to-body="true"
    :width="modalWidth"
    :show-close="false"
    custom-class="custom-scrollable"
  >
    <div class="flex justify-between -mt-8 mb-6 md:mb-8 bg-white w-full px-2">
      <span
        class="text-black-10 text-lg font-bold"
        style="word-break: normal"
        >{{ dialogTitle }}</span
      >
      <span class="cursor-pointer" @click="handleClose" test-id="closeIcon">
        <close-icon size="h-6 w-6" />
      </span>
    </div>

    <el-form
      @keyup.enter.native="validateForm('kycDetailsForm')"
      @submit.native.prevent="validateForm('kycDetailsForm')"
      label-position="top"
      :model="kycDetailsForm"
      :rules="rules"
      ref="kycDetailsForm"
    >
      <div class="flex flex-col px-2">
        <p class="flex items-center mb-4 w-full">
          <el-checkbox
            v-if="!isEntityType"
            v-model="isUltimateBeneficiaryOwner"
            class=""
          >
          </el-checkbox>
          <span
            v-if="!isEntityType"
            class="ml-3 w-full text-sm md:text-base"
            style="word-break: normal"
            >Select this Director as the Ultimate Beneficiary Owner (UBO)</span
          >
        </p>
        <!-- title -->
        <el-form-item v-if="!isEntityType" class="w-full" prop="title">
          <p>Title <span class="text-error-10">*</span></p>
          <el-select
            class="w-full"
            v-model="kycDetailsForm.title"
            placeholder="Select"
          >
            <el-option
              v-for="(title, index) in titles"
              :key="index"
              :label="title.label"
              :value="title.value"
            >
              {{ title.label }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="w-full" prop="name">
          <p>
            {{ isEntityType ? 'Entity ' : '' }}Name
            <span class="text-error-10">*</span>
          </p>
          <el-input class="w-full" v-model="kycDetailsForm.name"></el-input>
        </el-form-item>
        <template v-if="isEntityType">
          <div class="flex flex-col md:flex-row gap-2">
            <el-form-item class="w-full md:w-1/2" prop="idNumber">
              <p>Incorporation Number <span class="text-error-10">*</span></p>
              <el-input v-model.trim="kycDetailsForm.idNumber"></el-input>
            </el-form-item>

            <el-form-item class="w-full md:w-1/2" prop="shareholding">
              <p>Shareholding (%) <span class="text-error-10">*</span></p>
              <el-input v-model.trim="kycDetailsForm.shareholding" />
            </el-form-item>
          </div>
          <el-form-item prop="citizenship">
            <p>Country of Incorporation <span class="text-error-10">*</span></p>
            <el-select
              class="w-full"
              filterable
              remote
              v-model="kycDetailsForm.citizenship"
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="(country, index) in options"
                :key="index"
                :label="country.name"
                :value="country.code2"
              >
                {{ country.name }}
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-form-item v-if="!isEntityType" class="w-full" prop="phoneNumber">
          <p>Mobile Number <span class="text-error-10">*</span></p>
          <el-input
            class="w-full"
            v-model="kycDetailsForm.phoneNumber"
          ></el-input>
        </el-form-item>

        <div v-if="!isEntityType" class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full md:w-1/2" prop="gender">
            <p>Gender <span class="text-error-10">*</span></p>
            <el-select
              class="w-full"
              v-model="kycDetailsForm.gender"
              placeholder="Select"
            >
              <el-option
                v-for="(gender, index) in genders"
                :key="index"
                :label="gender.label"
                :value="gender.value"
              >
                {{ gender.label }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" prop="dateOfBirth">
            <p>Date of Birth <span class="text-error-10">*</span></p>
            <el-date-picker
              v-model="kycDetailsForm.dateOfBirth"
              type="date"
              placeholder="YYYY-MM-DD"
              class="w-full"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </div>

        <div v-if="!isEntityType" class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full md:w-1/2" prop="idType">
            <p>Valid ID Type <span class="text-error-10">*</span></p>
            <el-select
              class="w-full"
              v-model="kycDetailsForm.idType"
              placeholder="Select"
            >
              <el-option
                v-for="(gender, index) in validIdTypes"
                :key="index"
                :label="gender.label"
                :value="gender.value"
              >
                {{ gender.label }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" prop="idNumber">
            <p>ID Number <span class="text-error-10">*</span></p>
            <el-input v-model.trim="kycDetailsForm.idNumber"></el-input>
          </el-form-item>
        </div>
        <div v-if="!isEntityType" class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full md:w-1/2" prop="citizenship">
            <p>Citizenship <span class="text-error-10">*</span></p>
            <el-select
              class="w-full"
              v-model="kycDetailsForm.citizenship"
              placeholder="Select"
              filterable
              remote
              :remote-method="remoteMethodHandler"
            >
              <el-option
                v-for="(item, index) in citizenshipOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="w-full md:w-1/2" prop="shareholding">
            <p>
              Shareholding %
              {{ isUltimateBeneficiaryOwner ? '' : '(Optional)'
              }}<span v-if="isUltimateBeneficiaryOwner" class="text-error-10"
                >*</span
              >
            </p>
            <el-input
              class="w-full flex items-center"
              v-model.trim="kycDetailsForm.shareholding"
            >
            </el-input>
          </el-form-item>
        </div>
        <el-form-item prop="country">
          <p>
            Country of {{ isEntityType ? 'Operation' : 'Residence' }}
            <span class="text-error-10">*</span>
          </p>
          <el-select
            class="w-full"
            filterable
            remote
            v-model="kycDetailsForm.country"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="(country, index) in options"
              :key="index"
              :label="country.name"
              :value="country.code2"
            >
              {{ country.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!isEntityType && isMandatory"
          class="w-full"
          prop="identityNumber"
        >
          <p>
            {{ bvnTitle }}
          </p>
          <el-input
            class="w-full"
            type="number"
            v-model="kycDetailsForm.identityNumber"
          ></el-input>
        </el-form-item>
        <el-form-item class="w-full" prop="address">
          <p>Address<span class="text-error-10">*</span></p>
          <el-input class="w-full" v-model="kycDetailsForm.address"></el-input>
        </el-form-item>

        <div class="flex flex-col md:flex-row gap-2">
          <el-form-item class="w-full" prop="state">
            <p>State<span class="text-error-10">*</span></p>
            <el-select v-model="kycDetailsForm.state">
              <el-option
                v-for="(state, index) in GetStatesForCountry(
                  kycDetailsForm.country
                )"
                :key="index"
                :label="state.name"
                :value="state.name"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="w-full" prop="postalCode">
            <p>Postal Code<span class="text-error-10">*</span></p>
            <el-input
              class="w-full"
              v-model="kycDetailsForm.postalCode"
            ></el-input>
          </el-form-item>
        </div>

        <div class="my-3">
          <h4 class="text-base font-bold text-black-10">Documents to Attach</h4>
          <p class="text-gray-muted text-xs md:text-sm mt-1">
            We only allow JPG, PNG, GIF and PDF
          </p>
        </div>

        <template v-if="!isEntityType">
          <el-form-item prop="id_card">
            <p>Valid ID Card <span class="text-error-10">*</span></p>
            <el-input
              accept=".jpg,.jpeg,.png,.pdf,.gif"
              type="file"
              id="id_card_0"
              v-model="kycDetailsForm.id_card"
              @change="handleUpload('id_card_0')"
            >
              <i
                slot="suffix"
                class="bg-gray-25 text-xs md:text-sm removeItalics"
              >
                Choose file
              </i>
            </el-input>
          </el-form-item>

          <el-form-item prop="proof_of_address">
            <p>
              Proof of Address ( Date within the last three months )
              <span class="text-error-10">*</span>
            </p>
            <el-input
              accept=".jpg,.jpeg,.png,.pdf,.gif"
              type="file"
              id="proof_of_address_0"
              v-model="kycDetailsForm.proof_of_address"
              @change="handleUpload('proof_of_address_0')"
            >
              <i
                slot="suffix"
                class="bg-gray-25 text-xs md:text-sm removeItalics"
              >
                Choose file
              </i>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item prop="incorporation_certificate">
            <p>
              Incorporation Certificate <span class="text-error-10">*</span>
            </p>
            <el-input
              accept=".jpg,.jpeg,.png,.pdf,.gif"
              type="file"
              id="certificate_of_incorporation_0"
              v-model="kycDetailsForm.incorporation_certificate"
              @change="handleUpload('certificate_of_incorporation_0')"
            >
              <i
                slot="suffix"
                class="bg-gray-25 text-xs md:text-sm removeItalics"
              >
                Choose file
              </i>
            </el-input>
          </el-form-item>
          <el-form-item prop="shareholding_details">
            <p>Shareholding Details <span class="text-error-10">*</span></p>
            <el-input
              accept=".jpg,.jpeg,.png,.pdf,.gif"
              type="file"
              id="certified_copy_of_shareholding_0"
              v-model="kycDetailsForm.shareholding_details"
              @change="handleUpload('certified_copy_of_shareholding_0')"
            >
              <i
                slot="suffix"
                class="bg-gray-25 text-xs md:text-sm removeItalics"
              >
                Choose file
              </i>
            </el-input>
          </el-form-item>
        </template>
        <el-form-item prop="politicallyExposed" v-if="!isEntityType">
          <p class="text-sm md:text-base text-black font-medium my-2">
            Politically Exposed Person (PEP)
            <span class="text-error-10">*</span>
          </p>
          <el-radio-group v-model="kycDetailsForm.politicallyExposed">
            <el-radio label="yes">Yes</el-radio>
            <el-radio label="no">No</el-radio>
          </el-radio-group>
        </el-form-item>

        <button
          class="text-white bg-primary rounded-lg mt-5 h-12 md:h-14 w-full hover:opacity-90"
          type="submit"
          :disabled="isLoading"
        >
          <spinner
            v-if="isLoading"
            size="small"
            :spacing="40"
            :line-fg-color="$primaryColor"
          />
          <span v-else>Submit</span>
        </button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  ALL_COUNTRIES,
  GENDER_TYPES,
  PHONE_NUMBER_REGEX,
  VALID_ID_TYPES,
  TITLE_TYPES,
  CITIZENSHIP
} from '@/utils/constants.js'
import breakpoints from '@/utils/breakpoints.js'
import { GetStatesForCountry, ValidateKycInput } from '@/utils/helpers.js'
import kyc from '@/mixins/kyc.js'

export default {
  name: 'AddDirector',
  mixins: [kyc],
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue')
  },
  data () {
    var validatePhoneNumber = (rule, value, callback) => {
      if (!PHONE_NUMBER_REGEX.test(value)) {
        callback(new Error('Please input a valid phone number'))
      } else {
        callback()
      }
    }
    var validateBVN = (rule, value, callback) => {
      if (
        (this.kycDetailsForm.country === 'NG' ||
          this.kycDetailsForm.country === 'US') &&
        !value
      ) {
        callback(new Error('Please enter identity number'))
      } else {
        callback()
      }
    }
    return {
      shares: [
        {
          label: '25%',
          value: '25%'
        },
        {
          label: '26-35%',
          value: '26-35%'
        },
        {
          label: '36-45%',
          value: '36-45%'
        },
        {
          label: '46-55%',
          value: '46-55%'
        },
        {
          label: '56-65%',
          value: '56-65%'
        },
        {
          label: '66-75%',
          value: '66-75%'
        },
        {
          label: '76-85%',
          value: '76-85%'
        },
        {
          label: '86-95%',
          value: '86-95%'
        },
        {
          label: '96-100%',
          value: '96-100%'
        }
      ],
      isUltimateBeneficiaryOwner: false,
      isLoading: false,
      titles: TITLE_TYPES,
      citizenship: CITIZENSHIP,
      genders: GENDER_TYPES,
      validIdTypes: VALID_ID_TYPES,
      allCountries: ALL_COUNTRIES,
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      options: [],
      citizenshipOptions: [],
      kycStep: 5,
      directorsDocuments: [
        {
          name: 'id_card_0',
          file: {}
        },
        {
          name: 'proof_of_address_0',
          file: {}
        }
      ],
      entitysDocuments: [
        {
          name: 'certificate_of_incorporation_0',
          file: {}
        },
        {
          name: 'certified_copy_of_shareholding_0',
          file: {}
        }
      ],
      kycDetailsForm: {
        name: '',
        phoneNumber: '',
        gender: '',
        dateOfBirth: '',
        country: '',
        address: '',
        identityNumber: '',
        state: '',
        postalCode: '',
        idNumber: '',
        idType: '',
        politicallyExposed: '',
        id_card: '',
        proof_of_address: '',
        title: '',
        citizenship: '',
        shareholding: '',
        type: this.type,
        incorporationNumber: '',
        countryOfIncorporation: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please enter director's name",
            trigger: ['blur', 'change']
          },
          { validator: ValidateKycInput, trigger: ['blur', 'change'] }
        ],
        phoneNumber: [
          {
            required: true,
            message: 'Please enter phone number',
            trigger: ['blur', 'change']
          },
          {
            max: 14,
            message: 'Invalid phone number ',
            trigger: ['blur', 'change']
          },
          { validator: validatePhoneNumber, trigger: ['blur', 'change'] }
        ],
        gender: [
          {
            required: true,
            message: 'Please choose a gender',
            trigger: ['blur', 'change']
          }
        ],
        dateOfBirth: [
          {
            required: true,
            message: 'Please enter date of birth',
            trigger: ['blur', 'change']
          }
        ],
        idType: [
          {
            required: true,
            message: 'Please choose an ID type',
            trigger: ['blur', 'change']
          }
        ],
        identityNumber: [
          {
            message: 'Please enter identity number',
            trigger: ['blur', 'change']
          },
          {
            max: 12,
            message: 'Invalid identity number',
            trigger: ['blur', 'change']
          },
          { validator: validateBVN, trigger: ['blur', 'change'] }
        ],
        country: [
          {
            required: true,
            message: 'Please select a country',
            trigger: ['blur', 'change']
          }
        ],
        address: [
          {
            required: true,
            message: 'Please enter an address',
            trigger: ['blur', 'change']
          },
          { validator: ValidateKycInput, trigger: ['blur', 'change'] }
        ],
        state: [
          {
            required: true,
            message: 'Please enter a state',
            trigger: ['blur', 'change']
          }
        ],
        postalCode: [
          {
            required: true,
            message: 'Please enter a postal code',
            trigger: ['blur', 'change']
          },
          {
            max: 8,
            message: 'Invalid postal code',
            trigger: ['blur', 'change']
          }
        ],
        idNumber: [
          {
            required: true,
            message: 'Please enter a valid ID number',
            trigger: ['blur', 'change']
          },
          {
            max: 20,
            message: 'Invalid ID Number',
            trigger: ['blur', 'change']
          }
        ],
        proof_of_address: [
          {
            required: true,
            message: 'Please choose a valid proof of address',
            trigger: ['blur', 'change']
          }
        ],
        id_card: [
          {
            required: true,
            message: 'Please choose a valid ID card',
            trigger: ['blur', 'change']
          }
        ],
        politicallyExposed: [
          {
            required: true,
            message: 'Please select one',
            trigger: ['blur', 'change']
          }
        ],
        title: [
          {
            required: true,
            message: 'Please choose a title',
            trigger: ['blur', 'change']
          }
        ],
        citizenship: [
          {
            required: true,
            message: 'Please choose a citizenship',
            trigger: ['blur', 'change']
          }
        ],
        shareholding: [
          {
            required: false,
            trigger: ['blur', 'change']
          },
          { validator: this.validateShareHolding, trigger: ['blur', 'change'] }
        ],
        incorporationNumber: [
          {
            required: true,
            message: 'Please enter incorporation number',
            trigger: ['blur', 'change']
          }
        ],
        countryOfIncorporation: [
          {
            required: true,
            message: 'Please enter country of incorporation',
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    isEntityType () {
      return this.type === 'entity'
    },
    modalWidth () {
      return breakpoints.mdAndDown
        ? '90%'
        : breakpoints.lgAndDown
        ? '70%'
        : '38%'
    },
    isMandatory () {
      return (
        this.kycDetailsForm.country === 'NG' ||
        this.kycDetailsForm.country === 'US'
      )
    },
    bvnTitle () {
      switch (this.kycDetailsForm.country) {
        case 'NG':
          return 'BVN'
        case 'US':
          return 'SSN'
        default:
          return 'BVN'
      }
    },
    dialogTitle () {
      let title = 'Directors and Ultimate Beneficiary Owner Information'
      if (this.isEntityType) {
        title = this.uboShares10Plus
          ? 'Entities with more than 25% share'
          : 'Entities with less than 25% share'
      }
      return title
    }
  },
  methods: {
    GetStatesForCountry,
    setShareHoldingValidation () {
      if (this.isEntityType) this.rules.shareholding[0].required = true
    },
    validateShareHolding (rule, value, callback) {
      const decimalPattern = /^-?\d*(\.\d+)?$/

      if (value === '') {
        callback(new Error('Shareholding value is required'))
      } else if (!decimalPattern.test(value)) {
        callback(
          new Error('Shareholding value must be a valid number or decimal')
        )
      } else if (Number(value) < 0) {
        callback(new Error('Shareholding value cannot be less than 0'))
      } else {
        callback()
      }
    },
    remoteMethodHandler (query) {
      const queryLowerCase = query.toLowerCase()
      this.citizenshipOptions = this.citizenship.filter((item) =>
        item.value.toLowerCase().includes(queryLowerCase)
      )
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    uploadDocuments (formData) {
      const documentType = this.isEntityType
        ? 'entitysDocuments'
        : 'directorsDocuments'
      for (const index in this[documentType]) {
        const fileName = this[documentType][index].name
        const item = this[documentType][index].file
        if (item.name) {
          formData.append(fileName, item)
        }
      }
    },
    handleUpload (file) {
      const item = document.getElementById(file).files[0]
      const documentType = this.isEntityType
        ? 'entitysDocuments'
        : 'directorsDocuments'

      for (const doc in this[documentType]) {
        if (this[documentType][doc].name === file) {
          this[documentType][doc].file = item
        }
      }
    },
    validateForm (kycDetailsForm) {
      this.$refs[kycDetailsForm].validate((valid) => {
        if (valid) {
          this.submitKycStepFive()
        } else {
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    submitKycStepFive () {
      const formData = new FormData()
      this.uploadDocuments(formData)
      const directorInformation = {
        name: this.kycDetailsForm.name,
        phoneNumber: this.kycDetailsForm.phoneNumber,
        gender: this.kycDetailsForm.gender,
        dateOfBirth: this.kycDetailsForm.dateOfBirth,
        country: this.kycDetailsForm.country,
        address: this.kycDetailsForm.address,
        identityNumber: this.kycDetailsForm.identityNumber,
        state: this.kycDetailsForm.state,
        postalCode: this.kycDetailsForm.postalCode,
        idNumber: this.kycDetailsForm.idNumber,
        idType: this.kycDetailsForm.idType,
        id_card: this.kycDetailsForm.id_card,
        proof_of_address: this.kycDetailsForm.proof_of_address,
        isPoliticallyExposed: this.kycDetailsForm.politicallyExposed,
        type: this.kycDetailsForm.type,
        title: this.kycDetailsForm.title,
        citizenship: this.kycDetailsForm.citizenship,
        shareholding: this.kycDetailsForm.shareholding.toString()
      }
      formData.append(
        'directorsInformation',
        JSON.stringify([directorInformation])
      )
      const payload = {
        kycDetailsForm: formData,
        kycStep: Math.floor(this.kycStep)
      }

      this.submitKycDetailsStepFormUpload(payload)
    }
  },
  watch: {
    isUltimateBeneficiaryOwner: function (newVal) {
      this.kycDetailsForm.type = newVal ? 'ubo' : 'director'
      this.rules.shareholding[0].required = newVal
    },
    'kycDetailsForm.country' (newValue, oldValue) {
      this.kycDetailsForm.state = ''
    },
    immediate: true
  },
  mounted () {
    this.setShareHoldingValidation()
  }
}
</script>

<style scoped lang="scss">
button:disabled {
  opacity: 0.6;
  cursor: default;
}
:deep(.el-checkbox__inner) {
  height: 1.3rem;
  width: 1.3rem;
}
:deep(.el-checkbox__inner::after) {
  height: 0.6rem;
  left: 0.4rem;
  border-width: 2px;
  top: 0.15rem;
}
:deep(.el-checkbox__label) {
  font-weight: 300;
  font-size: 0.95rem;
}
:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: var(--color-primary);
}
</style>
